// extracted by mini-css-extract-plugin
module.exports = {"servicesContainer":"Services_servicesContainer__FQKP2","tag":"Services_tag__mWjbp","limitedHeight":"Services_limitedHeight__xeUsc","normalHeight":"Services_normalHeight__gRYtZ"};